import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { acknowledgeAlarmOran } from '@api/alarmHistory';

import { IAcknowledgeAlarmDTO } from '@interfaces/alarms/dto/alarmsDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes } from '@enums/common';

import { ACTIVE_ALARMS_ORAN_ACKNOWLEDGE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateAcknowledgeAlarmOranReturn {
	acknowledgeAlarm: UseMutateFunction<any, any, IAcknowledgeAlarmDTO, any>;
	isAcknowledgeAlarm: boolean;
}

export const useMutateAcknowledgeAlarmOran = ({
	onSuccess,
}: Partial<IOnSuccess>): IUseMutateAcknowledgeAlarmOranReturn => {
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IAcknowledgeAlarmDTO>({
		mutationKey: [ACTIVE_ALARMS_ORAN_ACKNOWLEDGE],
		mutationFn: acknowledgeAlarmOran,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.acknowledgeAlarm,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		acknowledgeAlarm: mutate,
		isAcknowledgeAlarm: isLoading,
	};
};
